var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured-product-info"},[(_vm.type === 'in_stock')?_c('img',{attrs:{"src":require("@/assets/icons/ui/in-stock_guarantee.png")}}):_c('img',{attrs:{"src":require("@/assets/icons/ui/new_style_icon.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }